import {useIntl} from 'react-intl'
import RateCircle from '../../../dashboard/component/components/semiCircle'
import {chartOptions} from '../enums/chartEnums'
import {Modal, ModalBody, ModalDialog, OverlayTrigger, Spinner, Tooltip} from 'react-bootstrap'
import {useState} from 'react'
import {KTIcon} from 'src/_metronic/helpers'

export default function RateAnalytics({
  rate,
}: {
  rate?: {
    analyticsRateDetails: string[]
    participationRate: number
    redemptionRate: number
  }
}) {
  const intl = useIntl()

  const chartInfos = [
    {
      title: intl.formatMessage({id: 'DASHBOARD.REDEMPTION_RATE'}),
      tooltip: intl.formatMessage({id: 'DASHBOARD.REDEMPTION_RATE_TOOLTIP'}),
      chartOptions,
      val: [rate?.redemptionRate || 0],
      get value() {
        return this.val
      },
      set value(value) {
        this.val = value
      },
    },
    {
      title: intl.formatMessage({id: 'DASHBOARD.PARTICIPATION_RATE'}),
      tooltip: intl.formatMessage({id: 'DASHBOARD.PARTICIPATION_RATE_TOOLTIP'}),
      chartOptions,
      val: [rate?.participationRate || 0],
      get value() {
        return this.val
      },
      set value(value) {
        this.val = value
      },
    },
  ]

  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <>
      <Modal
        centered
        size='lg'
        show={isModalOpen}
        onHide={() => {
          setIsModalOpen(false)
        }}
      >
        <ModalBody>
          <div className='d-flex justify-content-end border-0'>
            {/* begin::Close */}
            <div
              className='btn btn-sm btn-icon btn-secondary ms-2'
              onClick={() => {
                setIsModalOpen(false)
              }}
            >
              <i className='bi bi-x-lg text-white fs-xl' />
            </div>
            {/* end::Close */}
          </div>

          <table
            className='table align-middle table-row-dashed table-striped fs-6 gy-5 pb-4'
            id='kt_customers_table'
            data-tname='products'
          >
            <thead>
              <tr className='text-start fw-bold fs-7 gs-0'>
                <th
                  className='fs-3 text-secondary'
                  data-key='skuID'
                  style={{
                    width: 'auto',
                    textAlign: 'left',
                    paddingRight: '0px',
                    cursor: 'default',
                  }}
                >
                  SKU ID
                </th>
                <th
                  className='fs-3 text-secondary'
                  data-key='productName'
                  style={{
                    width: 'auto',
                    textAlign: 'left',
                    paddingRight: '0px',
                    cursor: 'default',
                  }}
                >
                  Product Name
                </th>
                <th
                  className='fs-3 text-secondary'
                  data-key='productName'
                  style={{
                    width: 'auto',
                    textAlign: 'left',
                    paddingRight: '0px',
                    cursor: 'default',
                  }}
                >
                  Product Category
                </th>
              </tr>
            </thead>
            <tbody className='fw-semibold '>
              <tr className='text-start'>
                <td>BGR008</td>
                <td>Espresso</td>
                <td>Hot Drinks</td>
              </tr>
              <tr className='text-start'>
                <td>BGR005</td>
                <td>Iced Americano</td>
                <td>Cold Drinks</td>
              </tr>
              <tr className='text-start'>
                <td>BGR002</td>
                <td>Matcha Latte</td>
                <td>Tea</td>
              </tr>
              <tr className='text-start'>
                <td>BGR004</td>
                <td>Cinnamon Roll</td>
                <td>Bakery</td>
              </tr>
              <tr className='text-start'>
                <td>BGR006</td>
                <td>New York Cheesecake</td>
                <td>Dessert</td>
              </tr>
              <tr className='text-start'>
                <td>BGR001</td>
                <td>Fresh Lemonade</td>
                <td>Beverage</td>
              </tr>
              <tr className='text-start'>
                <td>BGR003</td>
                <td>Blueberry Muffin</td>
                <td>Bakery</td>
              </tr>
              <tr className='text-start'>
                <td>BGR007</td>
                <td>Butter Croissant</td>
                <td>Bakery</td>
              </tr>
            </tbody>
          </table>
        </ModalBody>
      </Modal>
      <div className='d-flex justify-content-between gap-5 my-10'>
        <div className='card p-3 w-100 d-flex flex-column justify-content-between p-10 fs-2'>
          <div className='fs-1 fw-bold text-primary mb-7'>
            {intl.formatMessage({id: 'ANALYTICS.INSIGHTS_AT_A_GLANCE'})}
          </div>
          <div className='row align-items-center'>
            <div className='col-md-8 d-flex flex-column gap-3'>
              {/*  {rate?.analyticsRateDetails.map((rateDetail, index) => {
                return (
                  <div key={index} className='d-flex align-items-center'>
                    <span className='bullet bullet-dot bg-secondary me-5'></span>
                    {rateDetail}
                  </div>
                )
              })} */}

              <li className='list-unstyled d-flex align-items-center'>
                <span className='bullet bullet-dot bg-secondary me-5'></span>
                Peak hours for weekdays are between 5 PM and 6 PM and for weekends between 2 PM and
                4 PM.
              </li>
              <li className='list-unstyled'>
                <span className='bullet bullet-dot bg-secondary me-5'></span>
                <span
                  className='cursor-pointer pe-1 fw-bold border-secondary border-bottom border-3'
                  onClick={() => {
                    setIsModalOpen(true)
                  }}
                >
                  8 products{' '}
                </span>
                <span> generate 80% of total sales</span>
              </li>
              <li className='list-unstyled d-flex align-items-center'>
                <span className='bullet bullet-dot bg-secondary me-5'></span>
                Customers make a transaction every 15 days
              </li>
              <li className='list-unstyled d-flex align-items-center'>
                {' '}
                <span className='bullet bullet-dot bg-secondary me-5'></span>
                20% of customers have made more than one transaction
              </li>
              <li className='list-unstyled d-flex align-items-center'>
                {' '}
                <span className='bullet bullet-dot bg-secondary me-5'></span>
                Customers prefer to redeem their points on Fridays
              </li>
            </div>
            <div className='col-md-4'>
              <div className='row'>
                {chartInfos.map((chartInfo, index) => {
                  return (
                    <div className='col-md-6' key={index}>
                      <div className='text-center fs-1 fw-bold mb-3'>
                        {chartInfo.title}
                        <span className='position-relative'>
                          <OverlayTrigger
                            placement='top'
                            overlay={
                              <Tooltip>
                                {chartInfo.tooltip} {intl.formatMessage({id: 'DAILY_UPDATE'})}
                              </Tooltip>
                            }
                          >
                            <i className='bi bi-info-circle text-primary ms-1'></i>
                          </OverlayTrigger>
                        </span>
                      </div>
                      <RateCircle options={chartInfo.chartOptions} series={chartInfo.val} />
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
